export default "__VITE_ASSET__44bae820__"